import Vue from 'vue';

Vue.filter('numberToDollar', value => {
    return (value / 100).toFixed(2);
});